import ContentCard from "../components/ContentCard/ContentCard";

export default function UnderConstructionPage() {
  return (
    <div className="UnderConstruction">
      <ContentCard>
        <div>
          <h1>⚠️ --- Under Construction --- ⚠️</h1>
          <h1>Check back again soon to see added features to this site!</h1>
          <h1>
            <a id="back-button" href="javascript:history.back()">
              Go Back
            </a>
          </h1>
        </div>
      </ContentCard>
    </div>
  );
}
